import React, { useState } from "react";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { TableHeader } from "../../../commons";
import AssignedUsersTableData from "./AssignedUsersTableData";
import { GetAllAssignUserOfSingleClient } from "../../../../redux/auth/authTypes";

type AppProps = {
  tableHeader: [] | TableHeadersType[];
  allAssignUserOfSingleClient: GetAllAssignUserOfSingleClient | null;
  assignedUsers: number[];
  setAssignedUsers: React.Dispatch<React.SetStateAction<any>>;
};
const AssignedUsersTable = ({
  tableHeader,
  allAssignUserOfSingleClient,
  assignedUsers,
  setAssignedUsers,
}: AppProps) => {
  // const [selectAll, setSelectAll] = useState(false);
  const [isHeaderChecked, setIsHeaderChecked] = useState(false);
  const handleHeaderCheckboxChange = (checked: boolean) => {
    // setSelectAll(checked);
    setIsHeaderChecked(checked);
    if (checked && allAssignUserOfSingleClient?.data?.length) {
      const allUserIds =
        allAssignUserOfSingleClient?.data?.length > 0
          ? allAssignUserOfSingleClient?.data?.map((user: any) => user?.user_id)
          : [];
      setAssignedUsers(allUserIds);
    } else {
      setAssignedUsers([]);
    }
  };

  return (
    <div style={{ width: "100%" }}>
      <div className="table-bordered table-responsive">
        <table className="table table-striped">
          <thead className=" sticky-table-header">
            <TableHeader
              tableHeader={tableHeader}
              multiCheckBox={true}
              onCheckboxChange={handleHeaderCheckboxChange}
              isChecked={isHeaderChecked}
            />
          </thead>
          <tbody>
            <AssignedUsersTableData
              allAssignUserOfSingleClient={
                allAssignUserOfSingleClient ? allAssignUserOfSingleClient : null
              }
              tableHeader={tableHeader}
              assignedUsers={assignedUsers}
              setAssignedUsers={setAssignedUsers}
              setIsHeaderChecked={setIsHeaderChecked}
            />
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AssignedUsersTable;
